import React, { useEffect, useState } from 'react';
import { Box, Heading, Page, PageContent, Text } from 'grommet';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { API, AppConstants } from '@enrich/shared-lib';
import QueryString from 'qs';

export const NonActiveStudents = () => {
    const user = useOutletContext();
    const school = user.school;
    const { schoolSlug } = useParams();
    const navigate = useNavigate();
    const [incompleteResumeCount, setIncompleteResumeCount] = useState(0);
    const [noCoachMeetingCount, setNoCoachMeetingCount] = useState(0);
    const [unresponsiveCount, setUnresponsiveCount] = useState(0);

    useEffect(() => {
        let isActive = true;

        (async () => {
            const [incomplete, noMeeting, unresponsive] = await Promise.all([
                loadCount({
                    enrichProgramStatus: {
                        $in: AppConstants.nonActiveStudentStatuses,
                    },
                    school: school.id,
                    isResumeReady: { $eq: false },
                }),
                loadCount({
                    enrichProgramStatus: {
                        $in: AppConstants.nonActiveStudentStatuses,
                    },
                    school: school.id,
                    coachMeetingDatetime: { $null: true },
                }),
                loadCount({
                    enrichProgramStatus: {
                        $in: AppConstants.nonActiveStudentStatuses,
                    },
                    school: school.id,
                    communicationLevel: { $eq: 0 },
                }),
            ]);

            if (isActive) {
                setIncompleteResumeCount(incomplete);
                setNoCoachMeetingCount(noMeeting);
                setUnresponsiveCount(unresponsive);
            }
        })();

        return () => {
            isActive = false;
        };
    }, [school.id]);

    return (
        <Page
            kind="full"
            pad={{ top: '30px', horizontal: 'medium', bottom: '30px' }}>
            <PageContent gap="medium">
                <Heading level="3">Non-Active Students</Heading>
                <Box direction="row" gap="medium" wrap>
                    <StatCard
                        label="Incomplete Resume"
                        value={incompleteResumeCount}
                        onClick={() =>
                            navigate(
                                `/${schoolSlug}/non-active/incomplete-resume`,
                            )
                        }
                    />
                    <StatCard
                        label="Incomplete Coach Meeting"
                        value={noCoachMeetingCount}
                        onClick={() =>
                            navigate(
                                `/${schoolSlug}/non-active/incomplete-coach-meeting`,
                            )
                        }
                    />
                    <StatCard
                        label="Unresponsive"
                        value={unresponsiveCount}
                        onClick={() =>
                            navigate(
                                `/${schoolSlug}/non-active/unresponsive`,
                            )
                        }
                    />
                </Box>
            </PageContent>
        </Page>
    );
};

const StatCard = ({ label, value, onClick }) => (
    <Box
        pad="medium"
        elevation="small"
        round="small"
        align="center"
        gap="small"
        width="small"
        onClick={onClick}
        focusIndicator={false}
        style={{ cursor: 'pointer' }}>
        <Text size="xxlarge" weight="bold">
            {value}
        </Text>
        <Text size="small">{label}</Text>
    </Box>
);

const loadCount = async (filters) => {
    const query = QueryString.stringify({
        filters,
        pagination: { pageSize: 1 },
    });

    try {
        const response = await API.get(`/api/contacts?${query}`);
        return response.data.meta.pagination.total;
    } catch (error) {
        console.log(error);
        return 0;
    }
};
